import React, { useEffect, useState } from "react"
import Moment from "react-moment";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../store/auth";
import { getPartnerAllCandidate, loadPartnerAllCandidate } from "../store/partner";
import PurchaseOrders from "../../Components/ApplicantProcessing/PurchaseOrders";
import BulkInvoice from "../../Components/ApplicantProcessing/BulkInvoice";
import { setCurrentPageTitle, setCurrentRoute } from "../store/layoutUI";
import { getComponentUserStatus, getToolsCount, UpdateComponentsUserStatus } from "../store/tools";

const PARTNER_INVOICE_STYLES = {
    shell: {
        background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        borderRadius: "20px",
        boxShadow: "0 16px 40px rgba(15, 23, 42, 0.06)",
        overflow: "hidden"
    },
    hero: {
        padding: "20px 22px 16px 22px",
        background: "linear-gradient(135deg, #eff6ff 0%, #f8fafc 55%, #ffffff 100%)",
        borderBottom: "1px solid rgba(203, 213, 225, 0.75)"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    heroCopy: {
        flex: "1 1 420px",
        minWidth: "280px"
    },
    titleRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eff6ff",
        color: "#1d4ed8",
        fontSize: "15px",
        border: "1px solid rgba(191, 219, 254, 1)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        minWidth: 0
    },
    eyebrow: {
        display: "inline-block",
        marginBottom: "8px",
        color: "#2563eb",
        fontSize: "11px",
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase"
    },
    title: {
        margin: 0,
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 800,
        lineHeight: 1.25
    },
    subtitle: {
        margin: 0,
        color: "#64748b",
        fontSize: "13px",
        lineHeight: 1.5,
        maxWidth: "760px"
    },
    heroActionRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#334155",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    bulkButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(224, 231, 255, 1)",
        background: "#eef2ff",
        color: "#4338ca",
        padding: "7px 12px",
        fontSize: "12px",
        fontWeight: 700
    },
    statusBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 14px",
        borderRadius: "999px",
        border: "1px solid rgba(191, 219, 254, 1)",
        backgroundColor: "#ffffff",
        color: "#1d4ed8",
        fontSize: "12px",
        fontWeight: 700,
        boxShadow: "0 8px 22px rgba(37, 99, 235, 0.08)"
    },
    statsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "14px",
        padding: "18px 22px 0 22px"
    },
    statCard: {
        borderRadius: "16px",
        border: "1px solid rgba(226, 232, 240, 1)",
        backgroundColor: "#ffffff",
        padding: "16px",
        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)"
    },
    statLabel: {
        margin: 0,
        color: "#64748b",
        fontSize: "11px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase"
    },
    statValue: {
        margin: "10px 0 6px 0",
        color: "#0f172a",
        fontSize: "28px",
        fontWeight: 700,
        lineHeight: 1
    },
    statMeta: {
        margin: 0,
        color: "#475569",
        fontSize: "13px",
        lineHeight: 1.5
    },
    tableWrap: {
        padding: "18px 22px 22px 22px"
    },
    sectionTitle: {
        margin: "0 0 6px 0",
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 700
    },
    sectionSubtitle: {
        margin: "0 0 18px 0",
        color: "#64748b",
        fontSize: "13px"
    },
    tableShell: {
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "18px",
        overflow: "auto",
        backgroundColor: "#ffffff",
        boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
    },
    table: {
        marginBottom: 0
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "12px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        padding: "14px 16px"
    },
    tableCell: {
        verticalAlign: "middle",
        padding: "18px 16px",
        borderTop: "1px solid rgba(241, 245, 249, 1)",
        background: "#ffffff"
    },
    idPill: {
        display: "inline-flex",
        alignItems: "center",
        padding: "5px 10px",
        borderRadius: "999px",
        backgroundColor: "#e0f2fe",
        color: "#075985",
        fontSize: "12px",
        fontWeight: 700,
        marginBottom: "8px"
    },
    secondaryPill: {
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 10px",
        borderRadius: "999px",
        backgroundColor: "#f1f5f9",
        color: "#475569",
        fontSize: "12px",
        fontWeight: 600
    },
    candidateName: {
        margin: 0,
        color: "#0f172a",
        fontSize: "15px",
        fontWeight: 700,
        textTransform: "uppercase"
    },
    infoText: {
        display: "block",
        color: "#475569",
        fontSize: "13px",
        lineHeight: 1.5
    },
    onboardingBadge: {
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 12px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700
    },
    actionButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        minHeight: "36px",
        borderRadius: "999px",
        border: "1px solid rgba(224, 231, 255, 1)",
        background: "#eef2ff",
        color: "#4338ca",
        padding: "7px 14px",
        fontSize: "12px",
        fontWeight: 700,
        textDecoration: "none",
        whiteSpace: "normal",
        lineHeight: 1.25,
        textAlign: "center"
    },
    emptyState: {
        padding: "42px 24px",
        textAlign: "center",
        backgroundColor: "#ffffff"
    },
    emptyIcon: {
        width: "64px",
        height: "64px",
        margin: "0 auto 14px auto",
        borderRadius: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
        color: "#2563eb",
        fontSize: "26px"
    },
    emptyTitle: {
        margin: 0,
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 700
    },
    emptyText: {
        margin: "10px auto 0 auto",
        maxWidth: "520px",
        color: "#64748b",
        fontSize: "14px",
        lineHeight: 1.6
    }
};

export default function PartnerInvoices() {
    const route = [{ name: "Contract Management", url: "" }];

    const [candidateList, setCandidateList] = useState([]);
    const [candidateObj, setCandidateObj] = useState(null);
    const [poShowHide, setPoShowHide] = useState(false);
    const [bulkShowHide, setBulkShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [appStatus, setAppStatus] = useState(false);
    const [appApproved, setAppApproved] = useState(false);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const partnerAllCandidateSelector = useSelector(getPartnerAllCandidate);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);
    const toolsCountSelector = useSelector(getToolsCount);

    const navigate = useNavigate();
    const currentUser = getCurrentUser();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentPageTitle("Invoices and Payments"));
        dispatch(setCurrentRoute(route))
    }, [])

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (!userDetailsSelector)
            dispatch(loadUserDetails(usrId));
    }, []);

    useEffect(() => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            setUserDetails(userDetailsSelector);
            setAppStatus(userDetailsSelector?.appSubmit);
            setAppApproved(userDetailsSelector?.approved > 0);
            if (userDetailsSelector?.approved > 0)
                dispatch(loadPartnerAllCandidate(userDetailsSelector.partnerid, 0))
        }
    }, [userDetailsSelector]);

    useEffect(() => {
        if (partnerAllCandidateSelector.length > 0) {
            setCandidateList(partnerAllCandidateSelector);
            let candItems = "";
            partnerAllCandidateSelector.map((x, key) => {
                if (key > 0) candItems += ",";
                candItems += x.performerid;
            });

            const appObj = toolsCountSelector.filter(x => x.key === 0);
            let appCiid = 0;
            if (appObj.length > 0)
                appCiid = appObj[0].value;

            handleUpdateComponent(candItems, appCiid);
        } else {
            setCandidateList([]);
        }
    }, [partnerAllCandidateSelector]);

    const handleCandidateInnoice = (item) => {
        navigate("/CandidateInvoice", { state: item });
    }

    const handlePoShowHide = (obj) => {
        setPoShowHide(!poShowHide);
        setCandidateObj(obj);
    };

    const handleBulkShowHide = () => {
        setBulkShowHide(!bulkShowHide);
    };

    const handleUpdateComponent = (compItems, ciid) => {
        const comp = componentUserStatusSelector.filter(x => x.compId === 23);
        let updCompItems = "";
        if (comp.length > 0) {
            updCompItems = comp[0].compItems;
        }
        const compObj = {
            compName: "Partner Candidate Invoice",
            performerId: currentUser.id,
            compItems: compItems,
            ciid: ciid,
            wiid: 0,
            iiid: 0,
            compId: 23
        }
        if (compItems !== "" && compItems !== updCompItems) {
            dispatch(UpdateComponentsUserStatus(compObj));
        }
    }

    const getPendingPoCount = (obj) => {
        let poType = "recruiter";
        if (userDetails?.partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.partnerSign !== true && x.sendStatus === true).length || 0;
    }

    const getTotalPoCount = (obj) => {
        let poType = "recruiter";
        if (userDetails?.partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.sendStatus === true).length || 0;
    }

    const getPoCount = (obj) => {
        const pendingCount = getPendingPoCount(obj);
        const totalCount = pendingCount === 0 ? getTotalPoCount(obj) : pendingCount;
        const badgeClass = pendingCount === 0 ? "badge-success" : "badge-danger";

        return <span className={`badge badge-pill ${badgeClass} ml-2`}>
            {totalCount}
        </span>
    }

    const handleRefreshPartnerInvoices = () => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            setUserDetails(userDetailsSelector);
            dispatch(loadPartnerAllCandidate(userDetailsSelector.partnerid, 0))
        }
    }

    const pendingCount = candidateList.length - candidateList.filter(item => item.appSubmit).length;
    const totalPendingPoCount = candidateList.reduce((sum, item) => sum + getPendingPoCount(item), 0);
    const invoiceReadyCount = candidateList.filter(item => item.appSubmit).length;

    const getOnboardingBadgeStyle = (isComplete) => ({
        ...PARTNER_INVOICE_STYLES.onboardingBadge,
        backgroundColor: isComplete ? "#dcfce7" : "#fef3c7",
        color: isComplete ? "#166534" : "#92400e"
    });

    return <React.Fragment>

        <div className="mt-2">
            <style>{`
                .partner-invoices-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }

                @media (max-width: 991.98px) {
                    .partner-invoices-table {
                        min-width: 1040px;
                    }
                }
            `}</style>
            <div className="card shadow-none border-1" style={PARTNER_INVOICE_STYLES.shell}>
                <div style={PARTNER_INVOICE_STYLES.hero}>
                    <div style={PARTNER_INVOICE_STYLES.heroRow}>
                        <div style={PARTNER_INVOICE_STYLES.heroCopy}>
                            <div style={PARTNER_INVOICE_STYLES.titleRow}>
                                <span style={PARTNER_INVOICE_STYLES.titleIcon}>
                                    <i className="fa fa-money" aria-hidden="true"></i>
                                </span>
                                <div style={PARTNER_INVOICE_STYLES.titleText}>
                                    <h2 style={PARTNER_INVOICE_STYLES.title}>Invoices and Payments</h2>
                                    <p style={PARTNER_INVOICE_STYLES.subtitle}>
                                        Click on Go to Invoices button to generate monthly invoices for your candidates.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={PARTNER_INVOICE_STYLES.heroActionRow}>
                            <button
                                type="button"
                                className="btn btn-sm"
                                style={PARTNER_INVOICE_STYLES.refreshButton}
                                onClick={handleRefreshPartnerInvoices}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>
                            <button
                                className="btn btn-sm"
                                style={PARTNER_INVOICE_STYLES.bulkButton}
                                onClick={handleBulkShowHide}
                                disabled={!appApproved}
                            >
                                <i className="fa fa-files-o" aria-hidden="true"></i>
                                Generate Monthly Bulk Invoices
                            </button>
                        </div>
                    </div>
                </div>
                <div style={PARTNER_INVOICE_STYLES.statsGrid}>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <p style={PARTNER_INVOICE_STYLES.statLabel}>Total Candidates</p>
                        <p style={PARTNER_INVOICE_STYLES.statValue}>{candidateList.length}</p>
                        <p style={PARTNER_INVOICE_STYLES.statMeta}>Candidates available for invoice and payment tracking.</p>
                    </div>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <p style={PARTNER_INVOICE_STYLES.statLabel}>Invoice Ready</p>
                        <p style={PARTNER_INVOICE_STYLES.statValue}>{invoiceReadyCount}</p>
                        <p style={PARTNER_INVOICE_STYLES.statMeta}>Candidates with completed onboarding ready for invoice work.</p>
                    </div>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <p style={PARTNER_INVOICE_STYLES.statLabel}>Awaiting Onboarding</p>
                        <p style={PARTNER_INVOICE_STYLES.statValue}>{pendingCount}</p>
                        <p style={PARTNER_INVOICE_STYLES.statMeta}>Candidates still pending onboarding completion.</p>
                    </div>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <p style={PARTNER_INVOICE_STYLES.statLabel}>Pending eSign</p>
                        <p style={PARTNER_INVOICE_STYLES.statValue}>{totalPendingPoCount}</p>
                        <p style={PARTNER_INVOICE_STYLES.statMeta}>Purchase orders that still need attention before billing is finalized.</p>
                    </div>
                </div>
                <div style={PARTNER_INVOICE_STYLES.tableWrap}>

                    <div className="table-responsive" style={PARTNER_INVOICE_STYLES.tableShell}>
                        <table className="table align-items-center table-hover mb-0 partner-invoices-table" style={PARTNER_INVOICE_STYLES.table}>
                            <thead>
                                <tr>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Candidate #<br />IPCS ID</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Details</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Agency</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Duration<br />(Start-End)</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Onboarding<br />Status</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Purchase Order</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {candidateList.length > 0 && candidateList.map((item) => (
                                    <tr key={item.performerid}>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <span style={PARTNER_INVOICE_STYLES.idPill}>{item.performerid}</span>
                                            <br />
                                            <span style={PARTNER_INVOICE_STYLES.secondaryPill}>
                                                IPCS ID: {item.maxloans || "N/A"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <p style={PARTNER_INVOICE_STYLES.candidateName}>
                                                {item.performername} {item.lastName}
                                            </p>
                                            <span style={PARTNER_INVOICE_STYLES.infoText}>{item.performeremail || "Email not available"}</span>
                                            <span style={PARTNER_INVOICE_STYLES.infoText}>{item.contactNo ? getFormatedNumber(item.contactNo) : "Phone not available"}</span>
                                            <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                {getFieldData(
                                                    item.performerData,
                                                    "projectengagement",
                                                    "PositionTitle"
                                                ) || "Position title not available"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                {getFieldData(
                                                    item.performerData,
                                                    "projectengagement",
                                                    "AgencyName"
                                                ) || "Agency not available"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            {item.duration && (
                                                <React.Fragment>
                                                    <span style={PARTNER_INVOICE_STYLES.infoText}>{item.duration.duration} Months</span>
                                                    <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                        Start:{" "}
                                                        <Moment format="MMM Do YYYY">
                                                            {item.duration.startDate}
                                                        </Moment>
                                                    </span>
                                                    <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                        End:{" "}
                                                        <Moment format="MMM Do YYYY">
                                                            {item.duration.endDate}
                                                        </Moment>
                                                    </span>
                                                </React.Fragment>
                                            )}
                                            {!item.duration && (
                                                <span style={PARTNER_INVOICE_STYLES.infoText}>Duration not available</span>
                                            )}
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <span style={getOnboardingBadgeStyle(item.appSubmit)}>
                                                {item.appSubmit ? "Complete" : "Pending"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <button
                                                className="btn btn-sm"
                                                onClick={() => handlePoShowHide(item)}
                                                style={PARTNER_INVOICE_STYLES.actionButton}
                                            >
                                                View and eSign
                                                {getPoCount(item)}
                                            </button>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <button
                                                onClick={() => handleCandidateInnoice(item)}
                                                className="btn btn-sm btn-outline-primary"
                                                style={PARTNER_INVOICE_STYLES.actionButton}
                                            >
                                                Go To Invoices
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {candidateList.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="p-0">
                                            <div style={PARTNER_INVOICE_STYLES.emptyState}>
                                                <div style={PARTNER_INVOICE_STYLES.emptyIcon}>
                                                    <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                </div>
                                                <h4 style={PARTNER_INVOICE_STYLES.emptyTitle}>No invoice candidates available yet</h4>
                                                <p style={PARTNER_INVOICE_STYLES.emptyText}>
                                                    Candidates will appear here once they are linked to your partner account and ready for invoice and payment tracking.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <PurchaseOrders
            poShowHide={poShowHide}
            handlePoShowHide={handlePoShowHide}
            candidateObj={candidateObj}
        ></PurchaseOrders>
        <BulkInvoice
            bulkShowHide={bulkShowHide}
            handleBulkShowHide={handleBulkShowHide}
            candidateList={candidateList}
        ></BulkInvoice>
    </React.Fragment>
}
